import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Tab, Tabs, Divider } from '@mui/material';
import { Route, useParams } from 'react-router-dom';
import { AppContext } from '@/AppContext';
import ChannelList from './channels/ChannelList';
import ChatLogHistory from './history/ChatLogHistory';
import Networking from './networking/Networking';

const PREFIX = 'Chat';

const classes = {
  root: `${PREFIX}-root`,
  tabs: `${PREFIX}-tabs`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: `${theme.spacing(3)} ${theme.spacing(3)} 0 ${theme.spacing(3)}`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.tabs}`]: {
    flexShrink: 0,
    margin: '0 auto',
    maxWidth: 'max-content',
  },
}));

const Chat = props => {
  const appContext = useContext(AppContext);
  const { mid: meetupId } = useParams();

  const valueFromUrl = () => {
    const path = appContext.history.location.pathname;
    if (path.indexOf('channels') !== -1) {
      return 'channels';
    }
    if (path.indexOf('live-channel') !== -1) {
      return 'live-channel';
    }
    if (path.indexOf('logs') !== -1) {
      return 'logs';
    }
    if (path.indexOf('news') !== -1) {
      return 'news';
    }
    if (path.indexOf('networking') !== -1) {
      return 'networking';
    }
    return '';
  };

  return (
    <Root className={classes.root}>
      <Tabs
        className={classes.tabs}
        onChange={() => {}}
        scrollButtons='auto'
        value={valueFromUrl()}
        variant='scrollable'
      >
        <Tab
          label={'Каналы'}
          value={'channels'}
          onClick={() => {
            appContext.history.push('/m/' + meetupId + '/chat/channels');
          }}
        />
        <Tab
          label={'Нетворкинг'}
          value={'networking'}
          onClick={() => {
            appContext.history.push('/m/' + meetupId + '/chat/networking');
          }}
        />
        <Tab
          label={'Переписки'}
          value={'logs'}
          onClick={() => {
            appContext.history.push('/m/' + meetupId + '/chat/logs');
          }}
        />
      </Tabs>
      <Divider />
      <Route path='/m/:mid/chat/channels'>
        <ChannelList />
      </Route>
      <Route path='/m/:mid/chat/logs'>
        <ChatLogHistory />
      </Route>
      <Route path='/m/:mid/chat/networking'>
        <Networking />
      </Route>
    </Root>
  );
};

export default Chat;
